(function () {
  if (window.__aeGiftBoot) return;
  window.__aeGiftBoot = true;

  var cfg = window.aeGiftConfig || {};
  if (!cfg.enabled) return;

  var RECIPE_EBOOK = String(cfg.recipeEbookVariantId || '');
  var SHILAJIT_EBOOK = String(cfg.shilajitEbookVariantId || '');
  var SHILAJIT_PRODUCT_IDS = (cfg.shilajitProductIds || [])
    .map(function (id) { return String(id || '').trim(); })
    .filter(Boolean);
  var UBE_EBOOK = String(cfg.ubeEbookVariantId || '');
  var UBE_PRODUCT_IDS = (cfg.ubeProductIds || [])
    .map(function (id) { return String(id || '').trim(); })
    .filter(Boolean);
  var EBOOK4 = String(cfg.ebook4VariantId || '');
  var EBOOK4_PRODUCT_IDS = (cfg.ebook4ProductIds || [])
    .map(function (id) { return String(id || '').trim(); })
    .filter(Boolean);
  var EBOOK5 = String(cfg.ebook5VariantId || '');
  var EBOOK5_PRODUCT_IDS = (cfg.ebook5ProductIds || [])
    .map(function (id) { return String(id || '').trim(); })
    .filter(Boolean);
  var SHIPPING_THRESHOLD = Number(cfg.thresholdCents) || 0;
  var TIER2 = cfg.tier2 || {};
  var TIER2_VARIANT = String(TIER2.variantId || '');
  var TIER2_THRESHOLD = Number(TIER2.thresholdCents) || 0;
  var TIER3 = cfg.tier3 || {};
  var TIER3_VARIANT = String(TIER3.variantId || '');
  var TIER3_THRESHOLD = Number(TIER3.thresholdCents) || 0;

  if (!RECIPE_EBOOK && !SHILAJIT_EBOOK && !UBE_EBOOK && !EBOOK4 && !EBOOK5
      && !TIER2_VARIANT && !TIER3_VARIANT) return;

  var MAX_RETRIES = 3;
  var running = false;
  var shilajitEbookFailCount = 0;
  var ubeEbookFailCount = 0;
  var recipeEbookFailCount = 0;
  var ebook4FailCount = 0;
  var ebook5FailCount = 0;
  var tier2FailCount = 0;
  var tier3FailCount = 0;
  var lastCartFingerprint = '';

  function autoAddEbooks() {
    if (running) return;
    running = true;
    var runningSafety = setTimeout(function () { running = false; }, 10000);

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) {
          throw new Error('cart.js returned malformed payload');
        }
        var itemIds = cart.items.map(function (i) { return String(i.variant_id); });
        var hasSub = cart.items.some(function (i) { return i.selling_plan_allocation; });
        var hasShilajit = SHILAJIT_PRODUCT_IDS.length > 0 && cart.items.some(function (i) {
          return SHILAJIT_PRODUCT_IDS.indexOf(String(i.product_id)) !== -1;
        });
        var hasUbe = (UBE_PRODUCT_IDS.length > 0 && cart.items.some(function (i) {
          return UBE_PRODUCT_IDS.indexOf(String(i.product_id)) !== -1;
        })) || cart.items.some(function (i) {
          return String(i.variant_id) === '56312794972546'
            || String(i.product_id) === '15357997711746';
        });
        var hasEbook4Trigger = EBOOK4_PRODUCT_IDS.length > 0 && cart.items.some(function (i) {
          return EBOOK4_PRODUCT_IDS.indexOf(String(i.product_id)) !== -1;
        });
        var hasEbook5Trigger = EBOOK5_PRODUCT_IDS.length > 0 && cart.items.some(function (i) {
          return EBOOK5_PRODUCT_IDS.indexOf(String(i.product_id)) !== -1;
        });
        var qualifiesFreeShipping = cart.total_price >= SHIPPING_THRESHOLD;

        var qualifiesTier2 = TIER2_THRESHOLD > 0 && cart.total_price >= TIER2_THRESHOLD;
        var qualifiesTier3 = TIER3_THRESHOLD > 0 && cart.total_price >= TIER3_THRESHOLD;

        var fingerprint = itemIds.slice().sort().join(',');
        if (fingerprint !== lastCartFingerprint) {
          shilajitEbookFailCount = 0;
          ubeEbookFailCount = 0;
          recipeEbookFailCount = 0;
          ebook4FailCount = 0;
          ebook5FailCount = 0;
          tier2FailCount = 0;
          tier3FailCount = 0;
          lastCartFingerprint = fingerprint;
        }

        var recipeLine = RECIPE_EBOOK ? cart.items.find(function (i) {
          return String(i.variant_id) === RECIPE_EBOOK;
        }) : null;
        var shilajitLine = SHILAJIT_EBOOK ? cart.items.find(function (i) {
          return String(i.variant_id) === SHILAJIT_EBOOK;
        }) : null;
        var ubeLine = UBE_EBOOK ? cart.items.find(function (i) {
          return String(i.variant_id) === UBE_EBOOK;
        }) : null;
        var ebook4Line = EBOOK4 ? cart.items.find(function (i) {
          return String(i.variant_id) === EBOOK4;
        }) : null;
        var ebook5Line = EBOOK5 ? cart.items.find(function (i) {
          return String(i.variant_id) === EBOOK5;
        }) : null;
        var tier2Line = TIER2_VARIANT ? cart.items.find(function (i) {
          return String(i.variant_id) === TIER2_VARIANT;
        }) : null;
        var tier3Line = TIER3_VARIANT ? cart.items.find(function (i) {
          return String(i.variant_id) === TIER3_VARIANT;
        }) : null;

        var removeTasks = [];
        if (recipeLine && !qualifiesFreeShipping) {
          removeTasks.push({ kind: 'recipe ebook', lineKey: recipeLine.key });
        }
        if (shilajitLine && !hasShilajit) {
          removeTasks.push({ kind: 'shilajit ebook', lineKey: shilajitLine.key });
        }
        if (ubeLine && !hasUbe) {
          removeTasks.push({ kind: 'ube ebook', lineKey: ubeLine.key });
        }
        if (ebook4Line && !hasEbook4Trigger) {
          removeTasks.push({ kind: 'ebook4', lineKey: ebook4Line.key });
        }
        if (ebook5Line && !hasEbook5Trigger) {
          removeTasks.push({ kind: 'ebook5', lineKey: ebook5Line.key });
        }
        if (tier2Line && !qualifiesTier2) {
          removeTasks.push({ kind: 'tier2 reward', lineKey: tier2Line.key });
        }
        if (tier3Line && !qualifiesTier3) {
          removeTasks.push({ kind: 'tier3 reward', lineKey: tier3Line.key });
        }

        var addTasks = [];
        if (RECIPE_EBOOK && qualifiesFreeShipping && !recipeLine && recipeEbookFailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'recipe ebook',
            variantId: RECIPE_EBOOK,
            onFail: function () { recipeEbookFailCount++; }
          });
        }
        if (SHILAJIT_EBOOK && hasShilajit && !shilajitLine && shilajitEbookFailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'shilajit ebook',
            variantId: SHILAJIT_EBOOK,
            onFail: function () { shilajitEbookFailCount++; }
          });
        }
        if (UBE_EBOOK && hasUbe && !ubeLine && ubeEbookFailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'ube ebook',
            variantId: UBE_EBOOK,
            onFail: function () { ubeEbookFailCount++; }
          });
        }
        if (EBOOK4 && hasEbook4Trigger && !ebook4Line && ebook4FailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'ebook4',
            variantId: EBOOK4,
            onFail: function () { ebook4FailCount++; }
          });
        }
        if (EBOOK5 && hasEbook5Trigger && !ebook5Line && ebook5FailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'ebook5',
            variantId: EBOOK5,
            onFail: function () { ebook5FailCount++; }
          });
        }
        if (TIER2_VARIANT && qualifiesTier2 && !tier2Line && tier2FailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'tier2 reward',
            variantId: TIER2_VARIANT,
            onFail: function () { tier2FailCount++; }
          });
        }
        if (TIER3_VARIANT && qualifiesTier3 && !tier3Line && tier3FailCount < MAX_RETRIES) {
          addTasks.push({
            kind: 'tier3 reward',
            variantId: TIER3_VARIANT,
            onFail: function () { tier3FailCount++; }
          });
        }

        if (removeTasks.length === 0 && addTasks.length === 0) return;

        var removePromises = removeTasks.map(function (task) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: task.lineKey, quantity: 0 })
          }).then(function (res) {
            if (!res.ok) {
              console.error('[ae gift auto-remove] ' + task.kind + ' FAILED', res.status);
              return { ok: false };
            }
            return { ok: true };
          }).catch(function (err) {
            console.error('[ae gift auto-remove] ' + task.kind + ' network error', err);
            return { ok: false };
          });
        });

        return Promise.all(removePromises).then(function (removeResults) {
          var anyRemoved = removeResults.some(function (r) { return r && r.ok; });

          var addPromises = addTasks.map(function (task) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: [{ id: parseInt(task.variantId, 10), quantity: 1 }] })
            }).then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  console.error('[ae gift auto-add] ' + task.kind + ' FAILED', res.status, err);
                  task.onFail();
                  return { ok: false };
                }).catch(function () {
                  task.onFail();
                  return { ok: false };
                });
              }
              return { ok: true };
            }).catch(function (err) {
              console.error('[ae gift auto-add] ' + task.kind + ' network error', err);
              return { ok: false };
            });
          });

          return Promise.all(addPromises).then(function (addResults) {
            var anyAdded = addResults.some(function (r) { return r && r.ok; });
            if ((anyRemoved || anyAdded) && typeof window.refreshCart === 'function') {
              window.refreshCart();
            }
          });
        });
      })
      .catch(function (err) { console.error('[ae gift] chain error', err); })
      .then(function () {
        clearTimeout(runningSafety);
        running = false;
      });
  }

  function bootReconcile() {
    setTimeout(autoAddEbooks, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReconcile, { once: true });
  } else {
    bootReconcile();
  }

  document.addEventListener('cart-updated', autoAddEbooks);

  (function () {
    if (window.__aeGiftAddIntercepted) return;
    window.__aeGiftAddIntercepted = true;
    var _origFetch = window.fetch;
    if (typeof _origFetch !== 'function') return;

    window.fetch = function () {
      var url = arguments[0];
      var opts = arguments[1] || {};
      var isCartAdd = typeof url === 'string'
        && url.indexOf('/cart/add') !== -1
        && opts.method
        && String(opts.method).toUpperCase() === 'POST';
      var result = _origFetch.apply(this, arguments);
      if (isCartAdd) {
        result.then(function (res) {
          if (res && res.ok) autoAddEbooks();
        }).catch(function () {});
      }
      return result;
    };
  })();

  window.aeRunGiftReconcile = autoAddEbooks;
})();
